import Modal from '@src/common/Modal';
import React, { useState, useEffect } from 'react';
import secureStorage from "@src/config/encrypt";
import { sendOtpToForgotPassword, verifyOtpPassword, otpVerifiedToForgotPassword } from "@src/store/slices/user";
import FullPageLoader from '@common/FullPageLoader';
import { MAX_OTP_TIMER, CHANGE_PASSWORD_STEP, OTP_INDEXES } from '@src/config/constant';
import { useLanguage } from "@src/context/LanguageContext";

interface ChangePasswordModalProps {
    show: boolean;
    handleClose: () => void;
    onSuccess: (response: { show_success_popup: boolean; last_updated_pwd: string }) => void;
}

const ChangePasswordModalID = ({ show, handleClose, onSuccess }: ChangePasswordModalProps) => {

    const [step, setStep] = useState<any>(CHANGE_PASSWORD_STEP.EMAIL);

    const [inputField, setInputField] = useState({
        email: "",
        otp: "",
        password: "",
        confirm_password: "",
    });

    const [errField, setErrField] = useState<any>({});
    const [loading, setLoading] = useState(false);

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);

    const maxTime = MAX_OTP_TIMER;
    const [otpTimer, setOtpTimer] = useState(maxTime);
    const { translations} = useLanguage();

    /* ================= OTP TIMER ================= */
    useEffect(() => {
        if (step !== CHANGE_PASSWORD_STEP.VERIFY_OTP) return;

        const timer = setInterval(() => {
            setOtpTimer((t) => t - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [step]);

    /* ================= PREFILL EMAIL ================= */
    useEffect(() => {
        if (!show) return;

         // reset
        resetForm();

        const result = secureStorage.getItem("authAgentUserInfo");
        if (result?.user_data?.email) {
            setInputField((prev) => ({
                ...prev,
                email: result.user_data.email,
            }));
        }

        setStep(CHANGE_PASSWORD_STEP.EMAIL);
        setOtpTimer(maxTime);
    }, [show]);

    /* ================= INPUT HANDLER ================= */
    const inputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;

        if (name === "otp" && !/^\d{0,4}$/.test(value)) return;

        setInputField({ ...inputField, [name]: value });
        setErrField({ ...errField, [name]: "" });
    };

    /* ================= SEND OTP ================= */
    const sendOtp = () => {
        if (!inputField.email) {
            setErrField({ email: "Email is required" });
            return;
        }

        setLoading(true);
        sendOtpToForgotPassword({ email: inputField.email }).then((res) => {
            setLoading(false);
            if (res?.data) {
                setStep(CHANGE_PASSWORD_STEP.VERIFY_OTP);
                setOtpTimer(maxTime);
            }
        });
    };

    /* ================= RESEND OTP ================= */
    const resendOtp = () => {
        if (otpTimer >= 0) return;

        sendOtpToForgotPassword({ email: inputField.email }).then(() => {
            setOtpTimer(maxTime);
        });
    };

    /* ================= VERIFY OTP ================= */
    const verifyOtp = () => {
        if (!inputField.otp) {
            setErrField({ otp: "OTP is required" });
            return;
        }

        let data = {email : inputField.email , otp : inputField.otp}
            otpVerifiedToForgotPassword(data).then((res) => {
                setLoading(false)
                if (res && res.data) {
                    setStep(CHANGE_PASSWORD_STEP.NEW_PASSWORD);
                }

            });
        
    };

    /* ================= FINAL SUBMIT ================= */
  const submitNewPassword = () => {

    let errors: any = {};

    if (!inputField.password) {
        errors.password = "New password is required";
    }

    if (!inputField.confirm_password) {
        errors.confirm_password = "Confirm password is required";
    }

    if (
        inputField.password &&
        inputField.confirm_password &&
        inputField.password !== inputField.confirm_password
    ) {
        errors.confirm_password = "Passwords do not match";
    }

    if (Object.keys(errors).length > 0) {
        setErrField(errors);
        return;
    }

    setLoading(true);
    verifyOtpPassword(
        { otp: inputField.otp, password: inputField.password },
        false
    ).then((res: any) => {
        setLoading(false);
        if (res?.data) {
            onSuccess({
                show_success_popup: true,
                last_updated_pwd: res.data.last_updated_pwd,
            });
        }
    });
};



const handleOtpChange = (e: any, index: number) => {
    const value = e.target.value.replace(/\D/, "");
    if (!value) return;

    let otpArr = inputField.otp.split("");
    otpArr[index] = value;
    const newOtp = otpArr.join("").slice(0, 4);

    setInputField({ ...inputField, otp: newOtp });
    setErrField({ ...errField, otp: "" });

    // focus next box
    if (index < 3) {
        const nextInput = document.getElementById(`otp-${index + 1}`);
        nextInput && nextInput.focus();
    }
};

const handleOtpKeyDown = (e: any, index: number) => {
    if (e.key === "Backspace") {
        let otpArr = inputField.otp.split("");
        otpArr[index] = "";
        setInputField({ ...inputField, otp: otpArr.join("") });

        if (index > 0) {
            const prevInput = document.getElementById(`otp-${index - 1}`);
            prevInput && prevInput.focus();
        }
    }
};


const resetForm = () => {
    setInputField({
        email: "",
        otp: "",
        password: "",
        confirm_password: "",
    });
    setErrField({});
    setStep(CHANGE_PASSWORD_STEP.EMAIL);
    setOtpTimer(maxTime);
    setShowNewPassword(false);
    setShowConfirmNewPassword(false);
};

    useEffect(() => {
        if (show) document.body.classList.add("overflow-hidden");
        return () => {
            document.body.classList.remove("overflow-hidden");
        }
    }, [show])

    return (
        <>
            <FullPageLoader show={loading} />
            <div className="model-outer upload-error-popup change-passwoed-user-popup">
                <Modal show={show} handleClose={handleClose}>
                    <div className="modal-body">

                        {/* =================  EMAIL ================= */}
                        {step === CHANGE_PASSWORD_STEP.EMAIL && (
                            <>
                            <div className='modal-header'>
                                <h2> {translations?.PROFILE?.CHANGE_PASSWORD}</h2>
                                <span className='subheading'>{translations?.PROFILE?.CHANGE_PASS_MSG}</span>
                            </div>
                                <fieldset>
                                    <div className="material email-with-icon">

                                    
                               
                                        <input
                                            type="email"
                                            name="email"
                                            value={inputField.email}
                                            className="form-input"
                                            onChange={inputHandler}
                                            disabled={true}
                                        />
                                        <i className='ic-email1 icn-login'></i>
                                        <label data-label="email" className="form-label" />
                                        {errField.email && <span className="error-txt">{errField.email}</span>}
                                    </div>
                                </fieldset>
                            </>
                        )}

                        {/* =================  OTP ================= */}
                        {step === CHANGE_PASSWORD_STEP.VERIFY_OTP && (
                            <>
                                <h2 className="otp-heading">Verify OTP</h2>
                                <small className="otp-subheading">
                                    Enter the OTP sent to your registered email ID
                                </small>

                                <fieldset className="change-password-otp">
                                    <div className="material">
                                        <div className="otp-box-wrapper">
                                            {OTP_INDEXES?.map((i) => (
                                                <input
                                                    key={i}
                                                    id={`otp-${i}`}
                                                    type="text"
                                                    maxLength={1}
                                                    className="otp-box"
                                                    value={inputField.otp[i] || ""}
                                                    onChange={(e) => handleOtpChange(e, i)}
                                                    onKeyDown={(e) => handleOtpKeyDown(e, i)}
                                                />
                                            ))}
                                        </div>

                                        {/* <label data-label="Otp" className="form-label" /> */}
                                        {errField.otp && <span className="error-txt">{errField.otp}</span>}
                                    </div>

                                    <span
                                        onClick={resendOtp}
                                        className={`resend-otp-txt ${otpTimer < 0 ? 'resend-otp' : ''}`}
                                    >
                                        {otpTimer < 0 ? "Resend OTP" : `Resend in 0:${otpTimer}`}
                                    </span>
                                </fieldset>
                            </>
                        )}

                        {/* ================= PASSWORD ================= */}
                        {step === CHANGE_PASSWORD_STEP.NEW_PASSWORD && (
                            <>
                                <h2>Create New Password</h2>

                                <fieldset>
                                    <div className="material">
                                        <input
                                            type={showNewPassword ? "text" : "password"}
                                            name="password"
                                            value={inputField.password}
                                            className="form-input password-txt"
                                            onChange={inputHandler}
                                        />
                                        <label data-label="New Password" className="form-label" />
                                        <span
                                            className="password-show pwd-show-hide"
                                            onClick={() => setShowNewPassword(!showNewPassword)}
                                        />
                                        {errField.password && <span className="error-txt">{errField.password}</span>}
                                    </div>
                                </fieldset>

                                <fieldset>
                                    <div className="material">
                                        <input
                                            type={showConfirmNewPassword ? "text" : "password"}
                                            name="confirm_password"
                                            value={inputField.confirm_password}
                                            className="form-input password-txt"
                                            onChange={inputHandler}
                                        />
                                        <label data-label="Confirm New Password" className="form-label" />
                                        <span
                                            className="password-show pwd-show-hide"
                                            onClick={() => setShowConfirmNewPassword(!showConfirmNewPassword)}
                                        />
                                        {errField.confirm_password && (
                                            <span className="error-txt">{errField.confirm_password}</span>
                                        )}
                                    </div>
                                </fieldset>
                            </>
                        )}
                    </div>

                    <div>
                        {step === CHANGE_PASSWORD_STEP.EMAIL && <button className="btn-primary w-100" onClick={sendOtp}>Apply</button>}
                        {step === CHANGE_PASSWORD_STEP.VERIFY_OTP && <button className="btn-primary w-100" onClick={verifyOtp}>Verify</button>}
                        {step === CHANGE_PASSWORD_STEP.NEW_PASSWORD && <button className="btn-primary w-100" onClick={submitNewPassword}>Verify</button>}
                    </div>
                </Modal>
            </div>
        </>
    );
};

export default ChangePasswordModalID;
